/**
 * User-facing errors. The UI catches `AppError` and shows `message`; `details` carries
 * developer diagnostics that belong in `console.error`, not on screen.
 */
export class AppError extends Error {
  readonly code: string;
  readonly details?: unknown;

  constructor(code: string, message: string, details?: unknown) {
    super(message);
    this.name = 'AppError';
    this.code = code;
    this.details = details;
  }
}

export function isAppError(e: unknown): e is AppError {
  return e instanceof AppError;
}
